<template>
  <el-container class="app-container">
    <el-aside width="200px" class="menu">
      <div class="sf-logo">
        <img src="@/assets/sf-logo.png" alt="logo" />
      </div>
      <el-menu
        :default-active="currentMenu"
        :unique-opened="true"
        mode="vertical"
        text-color="#fff"
        @select="selectMenu"
        :router="true"
        :collapse-transition="false"
        :collapse="false"
      >
        <template v-for="(menu, index) in menuList">
          <el-submenu
            :index="menu.menuCode"
            v-if="menu.children && menu.children.length > 0"
            :key="index"
          >
            <template slot="title">
              <i :class="geneClass(menu.menuCode)"></i>
              <span>{{ menu.menuName }}</span>
            </template>

            <template v-for="(itemChild, i) in menu.children">
              <el-submenu
                v-if="
                  itemChild.children &&
                  itemChild.children.length &&
                  itemChild.children[0].menuType == 1
                "
                :index="itemChild.menuCode"
                :key="i"
              >
                <template slot="title">
                  <i :class="itemChild.icon"></i>
                  <span>{{ itemChild.menuName }}</span>
                </template>
                <el-menu-item
                  v-for="itemChild_child in itemChild.children"
                  :index="itemChild_child.menuCode"
                  :key="itemChild_child.menuCode"
                >
                  <span slot="title">{{ itemChild_child.menuName }}</span>
                </el-menu-item>
              </el-submenu>
              <el-menu-item
                v-else
                :index="itemChild.menuCode"
                :key="itemChild.menuCode"
                >{{ itemChild.menuName }}</el-menu-item
              >
            </template>
          </el-submenu>
          <el-menu-item
            ref="home"
            :data-index="menu.menuCode"
            :index="menu.menuCode"
            v-else
            :key="index"
          >
            <i :class="geneClass(menu.menuCode)"></i>
            <span slot="title">{{ menu.menuName }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="app-header" height="45px">
        <div class="account">
          <i class="iconfont sfzhanghao"></i>
          {{ userName }}
          <span class="currRole"
            ><span class="roleName" @click="onToggleRolelist">{{
              defaultRoleName ? defaultRoleName : "无角色"
            }}</span
            ><i
              class="el-icon-arrow-down arrowIcon"
              :class="{ reverse: isshowrolelist }"
            ></i
          ></span>
          <div class="rolelist" v-show="isshowrolelist">
            <div class="tenantbox">
              <div
                class="tenant"
                v-for="(item, index) in multiTenantList"
                :key="index"
              >
                <h5
                  class="tenantname"
                  :class="{ active: defaultTenantId == item.tenantId }"
                >
                  <i class="orgicon"></i>{{ item.tenantName }}
                </h5>
                <ul class="curr_roles">
                  <li
                    v-for="(i, k) in item.roleVOList"
                    :key="k"
                    :class="{ active: defaultRoleId == i.roleId }"
                    @click="onSwitchTenant(i.memberId, i.tenantId, i.roleId)"
                  >
                    {{ i.roleName }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="logoutbtn" @click="logout">退出</div>
          </div>
          <!-- <el-select
            class="roleSelect"
            v-model="dRoleId"
            @change="onChangeRole"
          >
            <el-option
              v-for="role in defaultRoleList"
              :key="role.roleId"
              :label="role.roleName"
              :value="role.roleId"
            >
              <span style="float: left">{{ role.roleName }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span> 
            </el-option>
          </el-select> -->
        </div>
      </el-header>
      <el-main class="scrollBar">
        <el-tabs
          class="main-tab"
          v-model="currPage"
          type="card"
          closable
          @tab-click="onTabClick"
          @tab-remove="removeTab"
        >
          <el-tab-pane
            v-for="option in tabOptions"
            :label="option.title"
            :name="option.name"
            :key="option.name"
          >
            <span slot="label">
              <i v-if="option.title == '首页'" class="el-icon-star-on"></i>
              {{ option.title }}
            </span>
          </el-tab-pane>
        </el-tabs>
        <div class="views" :style="{ 'min-height': dynaHeight + 'px' }">
          <router-view :key="key" @removePage="removeTab" />
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import store from "@/store";
import _ from "lodash";
import { _CONFIG_ } from "@/common/js/config.js"

export default {
  name: "layout",
  data() {
    return {
      currRoleId: null,
      isshowrolelist: false,
      currRoleName: "企业管理员",
      homePage: "/manage/HomePage",
      currentMenu: "/manage/HomePage",
      isCollapse: false,
      currPage: "",
      tabOptions: [],
      dRoleId: null,
      dynaHeight: document.documentElement.clientHeight - 95,
    };
  },
  methods: {
    ...mapActions([
      "authApi",
      "getMenu",
      "getStatus",
      "ChangeRoleApi",
      "logoutApi",
      "SwitchTenantApi",
    ]),
    onToggleRolelist() {
      this.isshowrolelist = !this.isshowrolelist;
    },
    geneClass(menuCode) {
      let baseClass = "icon ";
      let iconClass = "";
      switch (menuCode) {
        case "ShippinManagement":
          iconClass = "fahuo";
          break;
        case "OrderManager":
          iconClass = "dingdan";
          break;
        case "CapacityManagement":
          iconClass = "yunli";
          break;
        case "FinancialManagement":
          iconClass = "caiwu";
          break;
        case "BillingManager":
          iconClass = "fapiao";
          break;
        case "CompanyManagement":
          iconClass = "gongsi";
          break;
        case "ArchivmeHD":
          iconClass = "caiwurenminbizhifu";
          break;
        case "ProcessCenter":
          iconClass = "liuchengCenter";
          break;
        case "TransactionManager":
          iconClass = "jiaoyi";
          break;
        default:
          iconClass = "shouye";
          break;
      }
      return baseClass + iconClass;
    },
    addSubMenu(item) {
      let url = item.menuCode;
      let submenu = item.children.map((i) => i.menuCode).join("-");
      return url;
    },
    onSwitchTenant(memberId, tenantId, roleId) {
      console.log(roleId, this.defaultRoleId);
      if (roleId == this.defaultRoleId) return;
      this.SwitchTenantApi({
        memberId: memberId,
        tenantId: tenantId,
        roleId: roleId,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "切换成功",
        });
        location.replace(this.homePage);
      });
    },
    onChangeRole(roleId) {
      this.ChangeRoleApi({ roleId: roleId }).then((res) => {
        this.$message({
          type: "success",
          message: "切换成功",
        });
        location.replace(this.homePage);
      });
    },
    getInitUrl() {
      this.currentMenu = this.$route.fullPath;
    },
    initTabs() {
      if (this.tabOptions.length == 0) {
        this.tabOptions.push({
          title: "首页",
          name: this.homePage,
        });
      }
      this.currPage = "/manage/HomePage";
      if (this.$route.path === this.homePage && this.$route.fullPath.includes('jwt')) {
        window.history.replaceState(null, null, window._CONFIG_.redirect_home)
        return
      }
      if (this.$route.fullPath !== this.homePage) {
        this.tabOptions.push({
          title: this.$route.name,
          name: this.$route.fullPath,
        });
        this.currentMenu = this.$route.fullPath;
        this.currPage = this.$route.fullPath;
      }
    },
    selectMenu(index) {
      SfGather.add_event({
        event_id: index,
      });
      this.currentMenu = index;
    },
    addTab(path) {
      if (!this.tabOptions.filter((item) => item.name === path).length) {
        let paramaTitle = window.sessionStorage.getItem(path) ? JSON.parse(window.sessionStorage.getItem(path)).title : '';
        let title = undefined;
        if(paramaTitle) {
          title = paramaTitle;
        }else{
          title = this.$route.name ? this.$route.name : "404";
        }
        this.tabOptions.push({ title: title, name: this.$route.fullPath });
      }
      this.currPage = this.$route.fullPath;
    },
    removeTab(targetName) {
      let tabs = this.tabOptions;
      let activeName = this.currPage;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }

      this.currPage = activeName;
      this.currentMenu = activeName;
      this.$router.push(activeName);
      this.tabOptions = tabs.filter((tab) => tab.name !== targetName);
    },
    logout() {
      this.$confirm("你确定要退出吗?", "退出提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.logoutApi().then(() => {
            this.$message({
              type: "success",
              message: "退出成功!",
            });
            // setTimeout(() => {
            //   this.$router.push("/");
            // }, 300);
            sessionStorage.clear()
            // 退出跳转到B端系统
            const CONFIG = window._CONFIG_ || _CONFIG_
            const uri = CONFIG.logout_uri + encodeURIComponent(CONFIG.redirect_home)
            console.log(`退出地址：${decodeURIComponent(uri)}`)
            window.location.href = uri
          });
        })
        .catch(() => {});
    },
    onTabClick(tab) {
      let tabPath = tab.name;
      let routePath = this.$route.path;
      if (tabPath != routePath) {
        this.$router.push(tabPath);
      }
    },
    updateViewHeight() {
      this.$store.commit("UPDATEDHEIGHT", this.dynaHeight);
    },
  },
  mounted() {
    const that = this;
    this.updateViewHeight();
    window.onresize = _.debounce(() => {
      that.dynaHeight = document.documentElement.clientHeight - 95;
      this.updateViewHeight();
    }, 100);
    document.body.addEventListener("click", (event) => {
      if ("roleName" !== event.target.className) {
        setTimeout(() => {
          this.isshowrolelist = false;
        }, 100);
      }
    });
  },
  computed: {
    key() {
      return this.$route.fullPath;
    },
    ...mapGetters([
      "userName",
      "menuList",
      "defaultRoleId",
      "defaultRoleList",
      "multiTenantList",
      "defaultRoleName",
      "defaultTenantId",
    ]),
  },
  watch: {
    $route() {
      this.addTab(this.$route.fullPath);
    },
  },
  async created() {
    if (location.search) {
      const search = location.search
      const key = search.split('=')[0]
      const jwt = search.split('=')[1]
      const oldJWT = sessionStorage.getItem('jwt')
      if (key.includes('jwt') && jwt && oldJWT !== jwt) {
        sessionStorage.setItem('jwt', jwt)
        try {
          await this.authApi({ jwt })
        } catch (e) {
          // 登录失败，跳转到注册页
          if (e.msg === '当前门户用户不存在') {
            this.$router.push("/register")
          }
          return
        }
      }
    }
    sessionStorage.removeItem("orderListQueryParams");
    this.getMenu().then((res) => {
      this.dRoleId = res.defaultRoleId;
      // 获取货主信息的状态 status
       this.getStatus({ customerNo: res.customerNo });
      // 获取uid，若uid没有则跳转到B端系统
      this.uid = res.uid
      // 根据uid是否为空判断是否跳转B端系统
      // FIX 出现循环跳转
      if ((this.uid ?? '') === '') {
        
      }
    });
    this.getInitUrl();
    this.initTabs();
  },
};
</script>
<style lang="less" scoped>
.roleName {
  user-select: none;
  cursor: pointer;
}
.logoutbtn {
  cursor: pointer;
  border-top: 1px solid #eee;
  font-size: 14px;
  font-weight: 700;
  padding-left: 47px !important;
}
.tenantbox {
  padding: 10px 0 0 20px !important;
}
.tenant {
  &:not(:first-child) {
    border-top: 1px solid #eee;
    padding-top: 10px !important;
  }
}
.orgicon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url("~@/assets/icons/org-default.png") center/contain no-repeat;
  margin-right: 7px;
  position: relative;
  top: 4px;
}
.tenantname {
  font-size: 14px;
  line-height: 30px !important;
  &.active {
    color: #dc1e32;
    .orgicon {
      background-image: url("~@/assets/icons/org-selected.png");
    }
  }
}
.curr_roles {
  list-style: none;
  font-size: 13px;
  line-height: 40px !important;
  padding-left: 27px !important;
  margin-top: 5px;
  li {
    cursor: pointer;
    &.active {
      color: #dc1e32;
      font-weight: 700;
    }
  }
}
.rolelist {
  z-index: 99999;
  position: absolute;
  right: 0;
  top: 50px;
  width: 250px;
  height: auto;
  border: 1px solid #eee;
  background-color: #fff;
  box-shadow: 0 0 5px #ccc;
  transition: all 0.3s;
  border-radius: 5px;
}
.currRole {
  font-size: 14px;
  border-left: 1px solid #eee;
  padding: 0 15px !important;
  margin-left: 20px !important;
  height: 28px;
}
.arrowIcon {
  transition: transform 0.3s;
  margin-left: 5px;
  &.reverse {
    transform: rotate(180deg);
  }
}
.icon {
  width: 18px;
  height: 18px;
  display: inline-block;
  margin-right: 10px;
}
.shouye {
  background: url("~@/assets/menuIcon/shouye.png") center/contain no-repeat;
}
.jiaoyi {
  background: url("~@/assets/menuIcon/jiaoyi.png") center/contain no-repeat;
}
.fahuo {
  background: url("~@/assets/menuIcon/fahuo.png") center/contain no-repeat;
}
.yunli {
  background: url("~@/assets/menuIcon/yunli.png") center/contain no-repeat;
}
.caiwu {
  background: url("~@/assets/menuIcon/caiwu.png") center/contain no-repeat;
}
.dingdan {
  background: url("~@/assets/menuIcon/dingdan.png") center/contain no-repeat;
}
.gongsi {
  background: url("~@/assets/menuIcon/gongsi.png") center/contain no-repeat;
}
.liuchengCenter {
  background: url("~@/assets/menuIcon/liuchengCenter.png") center/contain
    no-repeat;
}
</style>
